export class DashboardFilterModel {
    constructor(
        public startDate: Date, 
        public endDate: Date, 
        public countryIds: Array<number>, 
        public providerIds: Array<number>, 
        public publisherIds: Array<number>, 
        public period: string) {
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-filter-model.ts